const starApprovedNationalAccountIds = new Set(["11", "85"]);

export const isStarApproved = (dealerNationalAccountId: string): boolean =>
  starApprovedNationalAccountIds.has(dealerNationalAccountId);
